import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleModal, toggleModalWithTimer } from 'apps/auth/actions/appAction';
import { deleteCard } from 'apps/auth/actions/cardsAction';
import { setNewForm } from 'apps/auth/actions/formAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import Form from 'apps/auth/components/form-multi/Form';
import { getField } from 'apps/auth/components/form-multi/utils';
import { ACH_ACCOUNT } from 'apps/auth/constants/Constants';
import { AUTH_CARD_DELETE } from 'apps/auth/constants/UrlConstants';

import DeleteCardOrAccountPopup from './DeleteCardOrAccountPopup';
import RenameCardOrAccountPopup from './RenameCardOrAccountPopup';

const FORM_NAME = 'deleteCardPopup';

const DeleteOrRenameCardPopup = ({ popupRef = null, ...props }) => {
    const selectedCard = props.selectedCard;

    useEffect(() => {
        const nameField = getField('name', selectedCard.alias, '', true, false, props.placeholder, 'text');
        const cardIdField = getField('id', selectedCard.id);
        const cardTypeField = getField('type', selectedCard.type);
        const forceField = getField('force', false);

        props.setNewForm(FORM_NAME, {
            [nameField.name]: nameField,
            [cardIdField.name]: cardIdField,
            [cardTypeField.name]: cardTypeField,
            [forceField.name]: forceField,
        });
    }, []);

    const onSubmitHandlerWithParams = (fields, data) => {
        const forceError = data.extra.force;
        const successText = data?.messages?.successText;

        if (!forceError) {
            const action = props.deleteCard(selectedCard.id);
            action.then(() => {
                popupRef.current?.close();
                props.toggleModalWithTimer(true, successText);
            });
        } else {
            popupRef.current?.close();
            popupRef.current?.open(<DeleteCardOrAccountPopup force={true} isACH={false} selectedCard={selectedCard} popupRef={popupRef} />);
        }
    };

    const renderLink = (id, component, text, iconName) => {
        return (
            <PopupButton
                id={id}
                iconName={iconName}
                type="button"
                text={text}
                onClick={() => {
                    popupRef.current?.open(component);
                }}
            />
        );
    };

    const renderDeleteLink = () => {
        if (props.form) {
            return (
                <Form id="delete_card_form_id" action={AUTH_CARD_DELETE} formName={FORM_NAME} validateForm={false} onSubmitHandler={onSubmitHandlerWithParams}>
                    <PopupButton type="submit" iconName="cross" text={props.cardsRemoveText} id="card_delete_action" />
                </Form>
            );
        } else {
            return false;
        }
    };

    const linkForAch = (
        <>
            {renderLink(
                'card_delete_action',
                <DeleteCardOrAccountPopup isACH={true} selectedCard={selectedCard} popupRef={popupRef} />,
                props.revokeAccessText,
                'cross',
            )}
        </>
    );

    const normalFlow = (
        <>
            {renderLink('card_rename_action', <RenameCardOrAccountPopup selectedCard={selectedCard} popupRef={popupRef} />, props.cardsRenameText, 'pencil')}
            {renderDeleteLink()}
        </>
    );

    return (
        <SimplePopup withoutBorder popupRef={popupRef}>
            {selectedCard.type === ACH_ACCOUNT ? linkForAch : normalFlow}
        </SimplePopup>
    );
};

const mapStateToProps = (state) => {
    return {
        form: state.form[FORM_NAME],
        cardsRemoveText: state.messages.pageMessages.cardsRemoveText,
        revokeAccessText: state.messages.pageMessages.revokeAccessText,
        cardsRenameText: state.messages.pageMessages.cardsRenameText,
    };
};
DeleteOrRenameCardPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    selectedCard: PropTypes.object,
};

export default connect(mapStateToProps, {
    toggleModalWithTimer,
    toggleModal,
    setNewForm,
    deleteCard,
})(DeleteOrRenameCardPopup);
